import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getDashboardItems() {
        return axios
            .get('/dashboard/dashboard-items')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDashboardItem({ commit }, payload = {
        item: null,
        paginate: '',
        query: ''
    }) {
        const item = payload.item,
            paginate = payload.paginate,
            query = payload.query

        commit('GET_DASHBOARD_ITEM_REQUEST', item)

        return axios
            .get(`/dashboard/dashboard-items/${item.id}${paginate}${query}`)
            .then(response => {
                commit('GET_DASHBOARD_ITEM_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_DASHBOARD_ITEM_FAILURE', item)
                handleApiError(error, `Pobranie danych dla widgetu ${item.codeName} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    getDashboardSections({ commit }) {
        return axios
            .get('/dashboard/dashboard-item-sections')
            .then(response => {
                commit('GET_DASHBOARD_SECTIONS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOrdersProductsPerDayNotSent({ commit }, payload = {
        query: ''
    }) {
        const query = payload.query

        return axios
            .get(`/dashboard/orders-products-per-day-not-sent${query}`)
            .then(response => {
                commit('GET_ORDERS_PRODUCTS_PER_DAY_NOT_SENT', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie szczegółowch danych o niewysłanych zamówieniach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOrdersProductsPerDayNotSentByOrder(context, payload = { query: ''}) {
        const query = payload.query

        return axios
            .get(`/dashboard/orders-products-per-day-not-sent-by-order${query}`)
            .then(response => {                
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie szczegółowch danych o niewysłanych zamówieniach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateOrdersProductsPerDayNotSentReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/dashboard/orders-products-per-day-not-sent?report=true${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Plik zostanie wkrótce przesłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateNumberOfOrdersPerImpositionReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/jobs/imposition-parts-summaries${query}&report=true`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Plik zostanie wkrótce przesłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOrdersProductsDelayed({ commit}, payload = {
        query: ''
    }) {
        const query = payload.query

        return axios
            .get(`/dashboard/orders-products-delayed${query}`)
            .then(response => {
                commit('GET_ORDERS_PRODUCTS_DELAYED', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie szczegółowch danych o opóźnionych zamówieniach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOrdersProductsDelayedByOrder(context, payload = {query: ''}) {
        const query = payload.query
        
        return axios
            .get(`/dashboard/orders-products-delayed-by-order${query}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie szczegółowch danych o opóźnionych zamówieniach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateOrdersDelayedReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/dashboard/orders-products-delayed?report=true${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Plik zostanie wkrótce przesłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setDashboardItems({ commit }, dashboardItem) {
        commit('SET_DASHBOARD_ITEMS', dashboardItem)
    },
    setDashboardFilters({ commit }, filters) {
        commit('SET_DASHBOARD_FILTERS', filters)
    },
    clearDashboardItems({ commit }) {
        commit('CLEAR_DASHBOARD_ITEMS')
    },
    clearDashboardFilters({ commit }) {
        commit('CLEAR_DASHBOARD_FILTERS')
    },
    setMachinesDashboard({ commit }, data) {
        commit('SET_MACHINES_DASHBOARD', data)
    },
    savePagination({ commit }, data) {
        commit('SAVE_PAGINATION', data)
    },
}